import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
const NumberInput = ({ label, min, max, value, onChange }) => {
    const intl = useIntl();
    const message = intl.formatMessage({ id: label });
    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleChange = (e) => {
        const newValue = Number(e.target.value).toString();
        if (/^\d*$/.test(newValue)) {
            const numericValue = Number(newValue);
            if ((numericValue >= min && numericValue <= max)) {
                setInputValue(newValue);
                onChange({ target: { value: newValue } });
            } else {
                setInputValue(value);
            }
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === '.') {
            e.preventDefault();
        }
    };

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('Text');
        if (/[^0-9]/.test(pasteData)) {
            e.preventDefault();
        }
    };

    const handleFocus = (e) => {
        e.target.select();
    };

    return (
        <>
            <label className="col-form-label mes-from-label-1 fw-semibold" htmlFor="rotation" dangerouslySetInnerHTML={{ __html: message }} />
            <input
                type="number"
                className="form-control h-54 bg-baby-blue"
                name="rotation"
                min={min}
                max={max}
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
                onFocus={handleFocus}
                step="1"
            />
        </>
    );
};

export default NumberInput;